import type { PersonaType, EmailAddressWrapper } from '../../../../service';
import { DistributionListMember, PersonType, uniqBy } from '../../../../shared';

export function convertPersonaTypeToPrivateDLMemberSuggestion(
    personaType: PersonaType
): DistributionListMember[] {
    const emailAddressWrappers: EmailAddressWrapper[] = [];
    if (personaType.EmailAddress) {
        emailAddressWrappers.push(personaType.EmailAddress);
    }
    personaType.EmailAddresses &&
        personaType.EmailAddresses.forEach(emailAddress => emailAddressWrappers.push(emailAddress));

    const members: DistributionListMember[] = [];
    // PDLs don't have EmailAddress in wrapper, instead we should use Id for uniquifying them.
    uniqBy(emailAddressWrappers, wrapper => wrapper.EmailAddress || wrapper.ItemId.Id).forEach(
        wrapper => {
            members.push({
                type: PersonType.PrivateDistributionListMember,
                emailAddressWrapper: { ...wrapper },
                displayName: personaType.DisplayName,
                isPdl:
                    personaType.EmailAddress &&
                    personaType.EmailAddress.MailboxType === 'PrivateDL',
                isManuallyTypedEmail: false,
            } as DistributionListMember);
        }
    );

    return members;
}

export function createManuallyTypedEntry(emailAddress: string): DistributionListMember {
    return {
        type: PersonType.PrivateDistributionListMember,
        displayName: emailAddress,
        emailAddressWrapper: { EmailAddress: emailAddress },
        isPdl: false,
        isManuallyTypedEmail: true,
    };
}
